import { Component, Input } from '@angular/core';
import { SharedService } from '@shared/service/sharedservice';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
  @Input() properties!: { level: string, path: string, current: boolean }[];

  constructor(private sharedService: SharedService) {}

  resolveLink(path: string): string {
    if (!path) {
      return path;
    }

    if (path.startsWith('/')) {
      const withoutLeadingSlash = path.replace(/^\/+/, '');
      const [firstSegment, ...rest] = withoutLeadingSlash.split('/');
      const normalized = (firstSegment || '').toLowerCase();

      if (['admin', 'staff', 'parent'].includes(normalized) && rest.length) {
        return this.sharedService.buildRoleBasedUrl(rest.join('/'));
      }

      if (['admin', 'staff', 'parent'].includes(normalized) && rest.length === 0) {
        return this.sharedService.buildRoleBasedUrl('');
      }
    }

    return path;
  }
}
